import { useState, useCallback } from 'react';
import toast from 'react-hot-toast';

export const useClipboard = () => {
  const [isSupported, setIsSupported] = useState(
    typeof navigator !== 'undefined' && 'clipboard' in navigator
  );

  const copyToClipboard = useCallback(async (text) => {
    if (!isSupported) {
      // Fallback for older browsers
      try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
        toast.success('Copied to clipboard!');
        return true;
      } catch (error) {
        toast.error('Failed to copy to clipboard');
        return false;
      }
    }

    try {
      await navigator.clipboard.writeText(text);
      toast.success('Copied to clipboard!');
      return true;
    } catch (error) {
      toast.error('Failed to copy to clipboard');
      return false;
    }
  }, [isSupported]);

  const readFromClipboard = useCallback(async () => {
    if (!isSupported) {
      return null;
    }

    try {
      const text = await navigator.clipboard.readText();
      return text;
    } catch (error) {
      console.error('Failed to read from clipboard:', error);
      return null;
    }
  }, [isSupported]);

  return {
    copyToClipboard,
    readFromClipboard,
    isSupported
  };
};